import {ChangeDetectorRef, Component, forwardRef, Input, OnInit, ViewChild} from "@angular/core";
import {SessionActions} from "../../../shared/actions/session.actions";
import {ApolloQueryObservable} from "apollo-angular";
import {ProcurementService} from "../../services/procurement-service/procurement.service";
import {DispatchList} from "../../../shared/view-model/store-management/dispatch-list.type";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {appInjector} from "../../../index";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {DispatchListItem} from "../../../shared/view-model/store-management/dispatch-list-item.type";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../shared/redux-store/store";
import {SubAdminUnitNeedsItemsComponent} from "../sub-admin-unit-needs-items/sub-admin-unit-needs-items.component";
import {ActivatedRoute} from "@angular/router";
import {Subject} from "rxjs/Subject";
import {Depot} from "../../../shared/view-model/store-management/depot.type";
import {DepotService, FetchDepotsResult} from "../../services/depot-service/depot.service";
import {isUndefined} from "util";
import {MedicineAuthFormComponent} from "../../withdrawal/medicine-auth-form/medicine-auth-form.component";
import {FileService} from "../../../core/visbos-core/http/file.service";
import {Location} from "@angular/common";
import {ApolloQueryResult} from "apollo-client";
import {FillUpDepotMutation} from "../../../shared/graphql/graphql.types";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {filter, map} from "rxjs/operators";
import {Stock} from '../../../shared/view-model/stock';
import {StockService} from '../../services/stock.service';
import * as _ from 'lodash';

@Component({
  selector: 'vb-sub-admin-unit-needs',
  templateUrl: './sub-admin-unit-needs.component.html',
  styleUrls: ['./sub-admin-unit-needs.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => SubAdminUnitNeedsComponent)}]
})
export class SubAdminUnitNeedsComponent extends AbstractVisbosControl<DispatchList, FormGroup> implements OnInit {

  @ViewChild(SubAdminUnitNeedsItemsComponent)
  dispatchItemsCmp: SubAdminUnitNeedsItemsComponent;

  @Input()
  activeDepotCuid: string;

  @Input()
  showDepotSelection: boolean = true;

  @Input()
  showPrintVouchersCheckBox: boolean = true;

  @Input()
  showSrcSelection: boolean = true;

  private dispatchList$: ApolloQueryObservable<any>;
  dispatchList: DispatchList;

  private activeDepotCuid$: Subject<string> = new Subject();
  private activeDepot$: ApolloQueryObservable<FetchDepotsResult>;
  activeDepot: Depot;

  managedDepots: Depot[];

  selectedItems = [];

  medicineAuthForm: FormGroup;
  generateVouchersCtrl: FormControl;

  srcAdminUnitCuid$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  searchResultColumns = [
    {name: 'Bezeichner', prop: 'label'},
    {name: 'Lager', prop: 'depot.label'},
    {name: 'Lagerplatz', prop: 'depot_yard.label'},
  ];

  searchFunction = (term) => this.stockService.searchStocksWithRelated(term, this.activeDepot ? this.activeDepot.cuid : null)
    .pipe(map(({stocks}) => {
      let st = [...stocks];
      return st.sort((st1: Stock, st2: Stock) => st1.label.localeCompare(st2.label));
    }));

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions,
              private fileService: FileService,
              private route: ActivatedRoute,
              private loc: Location,
              private depotService: DepotService,
              private procurementService: ProcurementService,
              private stockService: StockService,
              private ngRx: NgRedux<IAppState>) {
    super(fb, cd, sessionActions);

  }

  ngOnInit() {
    super.ngOnInit();

    this.generateVouchersCtrl = this.fb.control(false);

    if (!this.showSrcSelection) {
      this.srcAdminUnitCuid$.next(this.activeAdminUnitCuid);
    }

    this.activeDepot$ = this.depotService.getDepot(this.activeDepotCuid$);
    this.addComponentData(this.activeDepot$);
    this.addSubscription(this.activeDepot$.subscribe(res => {
      this.activeDepot = res.data.fetchDepots[0];
    }));

    this.dispatchList$ = this.procurementService.getDispatchListForDepot(
      this.activeDepotCuid$,
      this.srcAdminUnitCuid$.pipe(filter(i => i !== null))
    );
    this.addComponentData(this.dispatchList$);
    this.dataSubscriptions.push(
      this.dispatchList$.subscribe(res => {
        this.dispatchList = _.cloneDeep<DispatchList>(res.data.dispatchListForDepot);
        this.setDefaultValues(this.dispatchList);
      })
    );

    this.addSubscription(this.route.params.subscribe(params => {
        if (params.depotCuid) {
          this.activeDepotCuid$.next(params.depotCuid);
          this.showDepotSelection = false;
        }
      })
    );

    if (this.activeDepotCuid) {
      this.activeDepotCuid$.next(this.activeDepotCuid);
      this.showDepotSelection = false;
    }

  }

  onDepotSelected(depot: Depot) {
    this.activeDepotCuid$.next(depot.cuid);
  }

  buildControlContent(values?: DispatchList): FormGroup {
    return SubAdminUnitNeedsComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null],
      fill_up_date: [null, Validators.required],
      user_id: [null],
      supplier_administration_unit_id: [null, Validators.required],
      recipient_administration_unit_id: [null, Validators.required],
      fill_up_items: fb.array([], Validators.required)
    });
  }

  public setDefaultValues(item?: DispatchList): { [controlKey: string]: any } | any {

    if (!item) {
      return undefined;
    }

    let val = {
      cuid: AbstractVisbosControl.cuid(),
      fill_up_date: new Date().toISOString().slice(0, 10),
      supplier_administration_unit_id: this.srcAdminUnitCuid$.getValue() || this.ngRx.getState().session.activeAdminUnit,
      recipient_administration_unit_id: this.activeDepot ? this.activeDepot.administration_unit.cuid : null,
      user_id: this.ngRx.getState().session.user.cuid
    };

    if (!isUndefined(val)) {
      this.control.patchValue(val);
    }

    this.addDispatchItems(item, <FormArray>this.control.get('fill_up_items'));

    return val;

  }

  addDispatchItems(dispatchList: DispatchList, formArray: FormArray) {
    formArray.controls = [];
    let orderItems: DispatchListItem[] = dispatchList.dispatch_list_items;

    orderItems.forEach(item => {
      formArray.push(this.initDispatchItemControl(dispatchList, item))
    });
  }

  addDispatchItemForStock(stock: Stock, formArray: FormArray) {
    // Create displatch list item from stock
    const item: DispatchListItem = {
      cuid: AbstractVisbosControl.cuid(),
      label: stock.label,
      article_number: this.setValue(stock, 'stock_item.default_packing.article_number'),
      article_label: this.setValue(stock, 'stock_item.label'),
      product_packing: this.setValue(stock, 'stock_item.default_product.piece_packing'),
      amount: stock.required_amount ? stock.required_amount : 0,
      stock_item: stock.stock_item,
      source_stocks: stock.related_stocks,
      target_stocks: [stock],
      product_batches: []
    };

    // Add new item to existing dispatch list
    const newList = _.cloneDeep<DispatchList>(this.dispatchList);
    newList.dispatch_list_items.push(item);
    this.dispatchList = newList;

    // Add dispatch list item to form array
    formArray.push(this.initDispatchItemControl(this.dispatchList, item));
  }

  initDispatchItemControl(dispatchList?: DispatchList, values?: DispatchListItem): FormGroup {

    return this.fb.group({
      cuid: [this.setValue(values, 'cuid')],
      stock_item_id: [this.setValue(values, 'stock_item.cuid')],
      amount: [this.setValue(values, 'amount'), Validators.required],
      product_packing_id: [this.setValue(values, 'product_packing.cuid')],
      packing_unit: [this.setValue(values, 'product_packing.packing_unit.packing_unit_name')],
      packing_content: [this.setValue(values, 'product_packing.packing_amount')],
      price: [this.setValue(values, 'product_packing.packing_price')],
      source_stock_id: [this.setValue(values, 'source_stocks.0.cuid')],
      target_stock_id: [this.setValue(values, 'target_stocks.0.cuid'), Validators.required],
      product_batches: this.fb.array([])
    });

  }

  onGenerateDispatchListPdfClick() {
    return this.procurementService.generateDispatchListPDF(this.dispatchList).toPromise();
  }

  onDispatchItemsClick(): Promise<ApolloQueryResult<FillUpDepotMutation>> {

    let input = Object.assign({}, this.control.value);
    input.fill_up_items = input.fill_up_items.filter(item => this.selectedItems.find(sel => sel === item.cuid));

    const authData = this.medicineAuthForm ? this.medicineAuthForm.value : null;
    const generateVouchers: boolean = this.generateVouchersCtrl ? this.generateVouchersCtrl.value : false;

    return this.procurementService.fillUpDepot(input, authData, generateVouchers).toPromise();

  }

  onSelectedChanged(selected: any[]) {
    this.selectedItems = selected;

    let authItem: boolean = this.selectedItems && this.selectedItems.length > 0 && this.dispatchList.dispatch_list_items.findIndex(item => {
      return (this.selectedItems.findIndex(id => id === item.cuid) > -1) &&
        (item.source_stocks.findIndex(s => s.registration_required === true) > -1 ||
          item.target_stocks.findIndex(s => s.registration_required === true) > -1);
    }) > -1;

    if (!this.medicineAuthForm && authItem) {
      this.createMedicineAuthComponent();
    } else if (this.medicineAuthForm && !authItem) {
      this.removeMedicineAuthForm();
    }

  }

  canSend(): boolean {
    let items = this.selectedItems && this.selectedItems.length > 0;
    let auth = this.medicineAuthForm ? this.medicineAuthForm.valid : true;
    return items && auth;
  }

  canGenerateDispatchListPdf() {
    return this.dispatchList != null;
  }

  createMedicineAuthComponent() {
    this.medicineAuthForm = MedicineAuthFormComponent.initControl(this.fb);
    this.cd.detectChanges();
  }

  removeMedicineAuthForm() {
    this.medicineAuthForm = null;
    this.cd.detectChanges();
  }

  srcAdminUnitSelected(adminUnit) {
    this.srcAdminUnitCuid$.next(adminUnit ? adminUnit.cuid : null);
  }

  stockManuallyAdded(stock: Stock) {
    this.addDispatchItemForStock(stock, <FormArray>this.control.get('fill_up_items'))
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/sub-admin-unit-needs/sub-admin-unit-needs.component.ts